{
  "newFeature": "Un sélecteur d’application optimisé inclut désormais uniquement les applications auxquelles vous pouvez accéder dans un liste unique.",
  "newLayout": "Nouvelle disposition",
  "ok": "OK"
}
